import { render, staticRenderFns } from "./SimplifiedEditModal.vue?vue&type=template&id=fa59d34c&scoped=true&lang=pug"
import script from "./SimplifiedEditModal.vue?vue&type=script&lang=js"
export * from "./SimplifiedEditModal.vue?vue&type=script&lang=js"
import style0 from "./SimplifiedEditModal.vue?vue&type=style&index=0&id=fa59d34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa59d34c",
  null
  
)

export default component.exports